import React, { useMemo } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import SkeletonItem from './MediaListItemSkeleton';
import { MediaListItemDemo } from './MediaListItemDemo';
import { MediaListProps, MediafileType } from './types';
import { MediaListItemRenderer } from './MediaListItemRenderer';

const INITIAL_SKELETON_LENGTH = 50;

const MediaList = (props: MediaListProps) => {
  const {
    elementId,
    className,
    streamId,
    mediafiles,
    children,
    withDislikes,
    withLikes,
    withPlaytime,
    playtimeName,
    timezone,
    itemListSkeleton,
    streamDemo,
    isStreamPlaying,
    mediaListItemIcons,
  } = props;

  const skeletonArray = useMemo(
    () => Array.from(Array(Math.min(INITIAL_SKELETON_LENGTH, mediafiles.length || INITIAL_SKELETON_LENGTH)).keys()),
    [mediafiles.length]
  );

  const renderMediaFiles = (mediafile: MediafileType) => (
    <MediaListItemRenderer
      mediafile={mediafile}
      streamId={streamId}
      timezone={timezone}
      playtimeName={playtimeName}
      withDislikes={withDislikes}
      withLikes={withLikes}
      withPlaytime={withPlaytime}
      mediaListItemIcons={mediaListItemIcons}
      key={`${mediafile.id}_${mediafile.mediafileId}_${mediafile.filename}_${mediafile.type}_${mediafile.title}`}
    />
  );

  return (
    <div
      className={classNames(styles.MediaList, className)}
      id={elementId}>
      {mediafiles.length > 0 && streamDemo && (
        <MediaListItemDemo
          streamId={streamId}
          streamDemo={streamDemo}
          isStreamPlaying={isStreamPlaying}
        />
      )}

      {mediafiles.map(renderMediaFiles)}

      <section
        className={styles.MediaListInitialSkeleton}
        data-is-loaded={mediafiles.length > 0}>
        {skeletonArray.map((item) => itemListSkeleton ?? <SkeletonItem key={`mediafile_skeleton_item_${item}`} />)}
      </section>

      {children}
    </div>
  );
};

export default React.memo(MediaList);
